export default {
  GET_NOTES (state, data) {
    state.notes = data.data
  },
  GET_ALL_NOTES (state, data) {
    state.all_notes = data.data
  },
  GET_NOTE (state, data) {
    state.note = data.data
  },
  GET_DELETED_NOTES (state, data) {
    state.deleted_notes = data.data
  },
  GET_ALERTED_NOTE(state, data) {
		state.alerted_note = data.data;
	  },
}
